module.exports = __webpack_public_path__ + "img/7.ae0ed21c.png";